import { REHYDRATE } from 'redux-persist/constants'
import reducers, { generateReducers } from 'reducers'
import initialState from 'interview/initial-state'
import models from 'interview/models'
import * as candidateActions from 'interview/actions/candidate'
import * as jobOpeningActions from 'interview/actions/job-opening'
import * as personalInterviewActions from 'interview/actions/personal-interview'
import * as liveActions from 'interview/actions/live'
import sequencedInterviewReducer from './sequenced-interview'

const { modelReducers, formReducers } = generateReducers(models, initialState)

export default {

  ...reducers,

  interview(state = initialState.interview, action) {
    const newState = { ...state }

    switch (action.type) {
      case REHYDRATE: {
        const { interview: rehydratedState } = action.payload
        if (rehydratedState) {
          return rehydratedState
        }
        break
      }

      case candidateActions.CANDIDATE_RECEIVE: {
        newState.jobOpening = action.payload.opening
        if (action.payload.opening.type === 'sequenced') {
          newState.candidate.state = action.payload.state
        }
        break
      }

      case candidateActions.CANDIDATE_UPDATE_STATE_SUCCESS: {
        newState.candidate.state = action.state
        newState.candidate.stateChangedAt = action.stateChangedAt
        newState.candidate.answerSaved = false

        if (action.currentQuestion) {
          const currentState = state.sequencedInterview.interviewState
          newState.sequencedInterview.interviewState = { ...currentState, currentQuestion: action.currentQuestion }
        }
        break
      }

      case candidateActions.CANDIDATE_SAVE_RESPONSE_SUCCESS: {
        newState.candidate.answerSaved = action.answerSaved
        break
      }

      case candidateActions.CANDIDATE_ERROR: {
        newState.candidate.error = action.error
        break
      }

      case jobOpeningActions.JOB_OPENING_RECEIVE: {
        newState.jobOpening = action.payload
        break
      }

      case personalInterviewActions.PERSONAL_INTERVIEW_RECEIVE: {
        newState.personalInterview = {
          ...action.payload,
          isLoading: false,
        }
        break
      }

      case liveActions.LIVE_INTERVIEW_RECEIVE: {
        newState.liveInterview = {
          ...action.payload,
          isLoading: false,
        }
        break
      }

      case liveActions.LIVE_INTERVIEW_CREATE_CALENDAR_EVENT: {
        newState.liveInterview = {
          ...newState.liveInterview,
          isLoading: true,
        }
        break
      }

      case personalInterviewActions.PERSONAL_INTERVIEW_CREATE_CALENDAR_EVENT: {
        newState.personalInterview = {
          ...newState.personalInterview,
          isLoading: true,
        }
        break
      }
      default:
    }

    newState.sequencedInterview = sequencedInterviewReducer(newState.sequencedInterview, action)

    return newState
  },

  ...modelReducers,

  ...formReducers,

}
